// Module
var code = `<div class="flex-window stretch debug-advanced">
    <div class="flex-window-head">
        <div class="clearfix padding padding-sm">
            <div class="flex-header flex-horizontal flex-shrink-0 margin-bottom">
                <div class="btn-group">
                    <button type="button" class="btn btn-primary" data-bind="click: refresh, enable: !spinners.refresh(), css: { 'btn-spinner': spinners.refresh() }">
                        <i class="icon-refresh"></i>
                        <span>Refresh</span>
                    </button>
                </div>
                <div>
                    <input class="form-control" placeholder="Filter" data-bind="textInput: filter">    
                </div>
                <div>
                    <div class="text-muted info-block">
                        <div class="text-center"><small>Memory Mapped Files:</small></div>
                        <div class="text-center">
                            <small><strong data-bind="text: filesCount"></strong></small>
                        </div>
                    </div>
                </div>
                <div>
                    <div class="text-muted info-block">
                        <div class="text-center"><small>Size on disk:</small></div>
                        <div class="text-center">
                            <small><strong data-bind="text: totalSizeOnDisk"></strong></small>
                        </div>
                    </div>
                </div>
                <div>
                    <div class="text-muted info-block">
                        <div class="text-center"><small>Mapped size:</small></div>
                        <div class="text-center">
                            <small><strong data-bind="text: totalMappedSize"></strong></small>
                        </div>
                    </div>
                </div>
                <div class="flex-separator"></div>
            </div>
        </div>
        
    </div>
    <div class="flex-window-scroll">
        <div class="scroll-stretch">
            <div class="panel">
                <virtual-grid class="resizable documents-grid" params="controller: gridController, emptyTemplate: 'empty-memory-mapped-files-template'"></virtual-grid>
            </div>
        </div>
    </div>
</div>
${"<" + "script"} type="text/html" id="empty-memory-mapped-files-template">
    No entries found. 
${"<" + "/script"}>
<div class="tooltip json-preview lg js-memory-mapped-files-tooltip" style="opacity: 0">
</div>
`;
// Exports
export default code;